import React from 'react';
import styled from 'styled-components';

export const CodeSandbox: React.FC<React.PropsWithChildren<{sandBoxLink: string}>> = ({sandBoxLink}) => {
    return (
        <CodeSandboxIframe
            src={sandBoxLink}
            title="Code Preview"
            allow="accelerometer; ambient-light-sensor; camera; encrypted-media; geolocation; gyroscope; hid; microphone; midi; payment; usb; vr; xr-spatial-tracking"
            sandbox="allow-forms allow-modals allow-popups allow-presentation allow-same-origin allow-scripts"
        />
    );
};

const CodeSandboxIframe = styled.iframe`
    width: calc(100vw - 4px);
    height: calc(100vh - 65px);
`;
